import {createStrokeSVG} from './TEMPLATE'

// lucide: moon
export const Moon_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: [
    'M20.985 12.486a9 9 0 1 1-9.473-9.472c.405-.022.617.46.402.803a6 6 0 0 0 8.268 8.268c.344-.215.825-.004.803.401',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
